import getUrlParam from 'common/utils/url/getURLParam';

import { URL_PARAMS } from '../constants';

export const useURLParamActiveStation = () => {
  return getUrlParam(URL_PARAMS.activeStation);
};
